import $ from 'jquery';

export function deactivateEquipment(id){

  return $.ajax({
    method: "PUT",
    dataType: 'json',
    traditional: true,
    data: {},
    xhrFields: {
      withCredentials: true
   },
    url: `${process.env.REACT_APP_API}/equipments/${id}/deactivate`,
    
    headers: {
        "Authorization": "Bearer " + localStorage.getItem('accessToken'),
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
  }).then(res => res.data).catch(res => console.log("ERROR " , res))
}